import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { useAppNavigation } from '@common/hooks/useNavigation'
import { RouteKey } from 'src/routes'
import { SvgIconProps, BreadcrumbsProps as MUIBreadcrumbsProps } from '@mui/material'

export type BreadcrumbItem = {
  title: string
  route_key: RouteKey
  params?: Record<string, string | number>
  icon?: React.ComponentType<SvgIconProps>
}

type BreadcrumbProps = {
  items: BreadcrumbItem[]
  separator?: React.ReactNode
  maxItems?: number
} & MUIBreadcrumbsProps

export function Breadcrumb({ items, separator, maxItems, ...rest }: BreadcrumbProps) {
  const { getRoutePath } = useAppNavigation()
  return (
    <div>
      <Breadcrumbs maxItems={maxItems} aria-label="breadcrumb" separator={separator} {...rest}>
        {items.map((item: BreadcrumbItem, index: number) => {
          const path = getRoutePath(item.route_key, item.params)
          if (!path) {
            return null
          }
          return (
            <Link key={index} color="inherit" href={path} sx={{ display: 'flex', alignItems: 'center' }}>
              {item.icon ? <item.icon sx={{ mr: 0.5 }} /> : ''}
              {item.title}
            </Link>
          )
        })}
      </Breadcrumbs>
    </div>
  )
}
